// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"131": "2d88088c6b58566f","339": "270b9991e9d21834","782": "16f0a953cba24766",}[chunkId] + ".css"
}